<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-1">
            <i style="font-size: 50px; color: grey" class="fa fa-file"></i>
          </div>
          <div class="col-md-11" style="margin: 0; padding: 0">
            <h4 class="title-card">Reporte de objetivos y logros</h4>
            <span>Gestiona los objetivos y logros</span>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-md-3">
            <label for="fechainicial">Fecha inicial:</label>
            <input
              type="date"
              class="form-control"
              name="fechainicial"
              v-model="fechaInicial"
              id="fechainicial"
            />
          </div>
          <div class="col-md-3">
            <label for="fechafinal">Fecha final:</label>
            <input
              type="date"
              class="form-control"
              name="fechaFinal"
              v-model="fechaFinal"
              id="fechafinal"
            />
          </div>
          <div class="col-md-3" v-if="rol == 1">
              <label for="">Sede:</label>
              <select class="form-control" v-model="sede">
                <option

                  v-for="sede in SedesProgramacion"
                  :key="sede.sede"
                  :value="sede.sede"
                >
                  {{ sede.sede }}
                </option>
              </select>
              
            </div>
          <div class="col-md-3">
            <label for="" style="color: white">..</label> <br />
            <button @click="getData()" class="btn btn-success btn-fill">
              Buscar <i class="fa fa-search"></i>
            </button>
          </div>
          <div class="col-md-3">
            <label for="" style="color: white">fff</label> <br />
            <download-excel
              class="btn btn-excel btn-lg btn-fill"
              :data="json_data"
              :fields="json_fields"
              worksheet="My Worksheet"
              :name="
                'Reporte-objetivos-y-logros' +
                '-' +
                fechaInicial +
                '-' +
                '-' +
                fechaFinal
              "
              v-if="json_data != ''"
            >
              Exportar a excel <i class="fa fa-file"></i>
            </download-excel>
          </div>
        </div>
        <div class="row">
          <br />
          <br />
          <div class="col-md-12" v-if="data == ''">
            <center>
              <img
                src="/static/img/ICONOS/estadisticas.svg"
                alt="Imagen de datos vacios"
                width="70"
              />
              <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
            </center>
          </div>
          <div class="col-md-12" v-else>
            <div class="row">
              <div class="col-md-12"></div>
              <div class="col-md-12">
                <el-table
                  border
                  :data="data"
                  size="mini"
                  class="table-responsive"
                >
                  <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                  >
                  </el-table-column
                ></el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  data: () => ({
    ip: "https://avanti-erp.com/",
    fechaInicial: "",
    fechaFinal: "",
    data: [],
    rol: localStorage.getItem('rol'),
    sede: 'Sede Principal',
    SedesProgramacion: [],
    tableColumns: [
      {
        prop: "UsuEst", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Estado", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "paciente", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Paciente", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 250, //ANCHO DE LA COLUMNA
      },
      {
        prop: "PacIndice", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "idA", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 70, //ANCHO DE LA COLUMNA
      },
      {
        prop: "ObjFec", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "ObjFecCum", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha de cumplimiento", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 140, //ANCHO DE LA COLUMNA
      },
      {
        prop: "ObjUsu", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Terapeuta", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "ObjObj", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Objetivo", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 250, //ANCHO DE LA COLUMNA
      },
      {
        prop: "ObjLog", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Logro", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 250, //ANCHO DE LA COLUMNA
      },
      {
        prop: "ObjPor", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "%", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 60, //ANCHO DE LA COLUMNA
      },
    ],
    json_fields: {
      "Estado del paciente": "UsuEst",
      "Nombre del paciente": "paciente",
      "Indice de atención" : "PacIndice",
      "Fecha inicial": "ObjFec",
      "Fecha de cumplimiento": "ObjFecCum",
      "Terapeuta": "ObjUsu",
      "Objetivo": "ObjObj",
      "Logro": "ObjLog",
      "%": "ObjPor",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  methods: {
    getData: function () {

      if( this.fechaInicial == '' || this.fechaFinal == ''){
        alert('ERROR: Faltan fechas por seleccionar')
        return
      }
      this.$modal.show("carga");
      const sede = this.rol == 1 ? this.sede : localStorage.getItem("sede");
      const BASE_URL = `${this.ip}api/reporteObjetivos/${this.fechaInicial}/${this.fechaFinal}/${this.fechamenosdias()}/${sede}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          // this.data = res.data.data;
          let dateFormated = [];
          var datos = res.data.data;
          datos.forEach((element) => {
            var estado = "";
            var porcentaje = "";
            if (element.estado == 1) {
              estado = "A";
            } else {
              estado = "I";
            }

            if (element.ObjPor == 0 && element.ObjLog == null) {
              porcentaje = "";
            } else {
              porcentaje = element.ObjPor + "%";
            }
            dateFormated.push({
              paciente: element.PacNom1 + " " + element.PacApe1,
              PacIndice: Math.trunc(element.indiceAtencion) + '%',
              ObjFec: element.ObjFec,
              ObjFecCum: element.ObjFecCum,
              ObjObj: element.ObjObj,
              ObjLog: element.ObjLog,
              ObjPor: porcentaje,
              ObjUsu: element.ObjUsu,       
              UsuEst: estado,
            });

            this.data = dateFormated;
            this.json_data = dateFormated;
            
          });
          this.$modal.hide('carga')
        })
        .catch((err) => {
          this.$modal.hide('carga')
          alert('Ocurrió un error, intentelo de nuevo.')
          console.log(err);
        });
    },
    fechamenosdias: function () {
      let fecha = new Date();
      let fechaCalcular = new Date();
      if( new Date(this.fechaFinal) < fechaCalcular ){
        fecha = new Date(this.fechaFinal);
      }else{
        fecha = fechaCalcular;
      }

      fecha.setDate(fecha.getDate() - 90);

      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
      return fechaFormateada;
    },
    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    document.title = "Avanti | Reporte de objetivos y logros";
    if(localStorage.getItem('rol') == 1){
      this.emailsProgramacion();
    }
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.title-card {
  color: grey;
  margin-top: 1% !important;
  margin-bottom: 0% !important;
}

.btn {
  border-radius: 5px;
}

.titulo-mensaje {
  font-size: 15px;
  color: grey;
}

.el-table {
  border-radius: 10px;
}

.card-header {
  padding-bottom: 10px !important;
  background-color: #f3f2ee;
  border-radius: 15px !important;
}


.btn-excel{
  background-color: green;
  border-color:green;
}

.btn-excel:hover{
  background-color: white;
  border-color:green;
  color:green;
}
</style>


// WEBPACK FOOTER //
// src/components/Reportes/Objetivos.vue